export const environment = {
  production: false,
  environmentName: 'local',
  apiBaseUrl: '/api/',
  imagesBaseUrl: 'assets/images/',
};
